export default {
    api_url: process.env.API_URL,
    api_url_hubops: process.env.API_URL_HUBOPS,
    api_url_tms: process.env.API_URL_TMS,
    api_url_stagetms: process.env.API_URL_STAGETMS,
    xbmasterapi_url: process.env.XBMASTERAPI_URL,
    allocateRuleapi_url: process.env.ALLOCATERULEAPI_URL,
    shipmentupdates_url: process.env.SHIPMENTUPDATES_URL,
    lastmile_url: process.env.LASTMILE_URL,
    usermanagement_url :process.env.USERMANAGEMENT_URL,
    lastmile_url_Without_Expose :process.env.lastmile_url_Without_Expose,
    iptracking_url:process.env.IPTRACKING_URL,
    userauthentication_url:process.env.API_URL_USERAUTHENTICATION,
    google_map_flag:true,
    api_url_kavach_auth:process.env.API_URL_KAVACH_AUTH,
    kavach_client_id:'hubops-ui',
    isKavachLogin:true,
    // HUB-8196: product paused full Release Hold; set true to show button again.
    isCwbHoldReleaseEnabled: false,
    cloudfronturl:process.env.Cloud_Front_URL,
    TMSRedirectionalUrl:process.env.TMSRedirectionalUrl,
    CRMRedirectionalUrl:process.env.CRMRedirectionalUrl




    // api_url: 'https://stageusermanagementapi.xbees.in/api/',
    // api_url_hubops: 'https://huboperation-apistage.xbees.in/api/',
    // api_url_tms: 'https://stagetmsapi.xbees.in/',
    // api_url_stagetms: 'https://stagetmsapi.xbees.in/',
    // xbmasterapi_url: 'https://stagexbmasterapi.xbees.in/expose/',
    // allocateRuleapi_url: 'https://huboperation-apistage.xbees.in/api/',
    // shipmentupdates_url: 'https://apistaging-shipmentupdates.xbees.in/',
    // lastmile_url: 'https://lastmileallocationpod-apistage.xbees.in/expose/',
    // usermanagement_url: 'https://stageautoallocation-app.xbees.in/api/',
    // lastmile_url_Without_Expose: 'https://lastmileallocationpod-apistage.xbees.in/',
    // iptracking_url:'https://stageiptracking.xbees.in/api/',
    // userauthentication_url:'https://stageusermanagementapi.xbees.in/api/',
    // google_map_flag:true,
    // api_url_kavach_auth:'https://stage-auth.xbees.in',
    // kavach_client_id:'hubops-ui',
    // isKavachLogin:true,
    // cloudfronturl:'https://d39ohhrtdl20fq.cloudfront.net',
    // TMSRedirectionalUrl:'https://stagetmsapp.xbees.in/#/',
    // CRMRedirectionalUrl:'https://stagecltcrm-frontend.xbees.in/#/'
}



// WEBPACK FOOTER //
// ./src/constants.js